import i18n from '@/i18n';

const state = () => {
  return {
    menu: [
      {
        icon: 'HomeIcon',
        pageName: '',
        title: i18n.t('nav.main'),
        group: 'main',
        subMenu: [
          {
            icon: 'BarChart2Icon',
            pageName: 'Dashboard',
            title: i18n.t('nav.dashboard'),
          },
          {
            icon: 'UserIcon',
            pageName: 'Admins',
            title: i18n.t('nav.admins'),
          },
        ],
      },
      {
        icon: 'UserIcon',
        pageName: 'Officers',
        group: 'officers',
        title: i18n.t('nav.officers'),
      },
      'divider',
      {
        icon: 'UserIcon',
        pageName: 'Customers',
        group: 'customers',
        title: i18n.t('nav.customers'),
      },
      {
        icon: 'LayersIcon',
        pageName: '',
        title: i18n.t('nav.loans'),
        group: 'loans',
        subMenu: [
          {
            pageName: 'LoansActive',
            title: i18n.t('nav.loansActive'),
          },
          {
            pageName: 'LoansPending',
            title: i18n.t('nav.loansPending'),
          },
          {
            pageName: 'LoansOverdue',
            title: i18n.t('nav.loansOverdue'),
          },
          {
            pageName: 'LoansClosed',
            title: i18n.t('nav.loansClosed'),
          },
        ],
      },
      {
        icon: 'FlagIcon',
        pageName: '',
        title: i18n.t('nav.reports'),
        group: 'reports',
        subMenu: [
          {
            pageName: 'ReportLoan',
            title: i18n.t('nav.reportLoan'),
          },
          {
            pageName: 'ReportOverdueLoan',
            title: i18n.t('nav.reportOverdueLoan'),
          },
          {
            pageName: 'ReportExtendedLoanTerm',
            title: i18n.t('nav.reportExtendedLoanTerm'),
          },
          {
            pageName: 'ReportLoanRepayment',
            title: i18n.t('nav.reportLoanRepayment'),
          },
          {
            pageName: 'ReportEndDay',
            title: i18n.t('nav.reportEndDay'),
          },
          {
            pageName: 'CreditAccountBalance',
            title: i18n.t('nav.creditAccountBalance'),
          },
        ],
      },
      {
        icon: 'BookOpenIcon',
        pageName: '',
        title: i18n.t('nav.generalJournal'),
        group: 'generalJournal',
        subMenu: [
          {
            pageName: 'CustomerTransactions',
            title: i18n.t('nav.customerTransactions'),
          },
          {
            pageName: 'GeneralJournal',
            title: i18n.t('nav.generalJournal'),
          },
          {
            pageName: 'GeneralLedger',
            title: i18n.t('nav.generalLedger'),
          },
        ],
      },
      'divider',
      {
        icon: 'SettingsIcon',
        pageName: '',
        title: i18n.t('nav.loanSettings'),
        group: 'loanSettings',
        subMenu: [
          {
            pageName: 'LoanAccounts',
            title: i18n.t('nav.loanAccounts'),
          },
          {
            pageName: 'LoanProducts',
            title: i18n.t('nav.loanProducts'),
          },
        ],
      },
      {
        icon: 'SettingsIcon',
        pageName: '',
        title: i18n.t('nav.settings'),
        group: 'settings',
        subMenu: [
          {
            pageName: 'DegreeOfEducation',
            title: i18n.t('nav.degreeOfEducation'),
          },
          {
            pageName: 'HouseTypes',
            title: i18n.t('nav.houseTypes'),
          },
          {
            pageName: 'Employment',
            title: i18n.t('nav.employment'),
          },
          {
            pageName: 'WhoIsThisPerson',
            title: i18n.t('nav.whoIsThisPerson'),
          },
          {
            pageName: 'Banks',
            title: i18n.t('nav.banks'),
          },
          {
            pageName: 'WorkPositions',
            title: i18n.t('nav.workPositions'),
          },
          {
            pageName: 'Accounts',
            title: i18n.t('nav.accounts'),
          },
        ],
      },
    ],
  };
};

const getters = {
  menu: state => state.menu,
};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
